import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Component to protect routes based on user authentication and role
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { currentUser } = useAuth();
  
  // If not logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  
  // If user doesn't have the required role, redirect to appropriate dashboard
  if (allowedRoles.length > 0 && !allowedRoles.includes(currentUser.role)) {
    // Redirect to the appropriate dashboard based on role
    return <Navigate to={`/${currentUser.role}`} replace />;
  }
  
  // User is authenticated and has the required role
  return children;
};

export default ProtectedRoute;
